__turbopack_context__.v({
  "error": "Notification-module__WJ9jqa__error",
  "notification": "Notification-module__WJ9jqa__notification",
  "success": "Notification-module__WJ9jqa__success",
  "title": "Notification-module__WJ9jqa__title",
  "warning": "Notification-module__WJ9jqa__warning",
});
